export const STORE_VALIDATION = {
    name: {
        required: 'Nama store wajib diisi',
    },
    city_id: {
        required: 'Kota wajib diisi',
    },
    address: {
        required: 'Alamat store wajib diisi',
    },
    phone_number: {
        minimum: {
            value: 8,
            message: 'Nomor handphone minimal 8 angka',
        },
    },
    opening_time: {
        required: 'Jam buka wajib diisi',
    },
    closing_time: {
        required: 'Jam tutup wajib diisi',
    },
    map_url: {
        required: 'Link maps wajib diisi',
    },
}

export const BANNER_VALIDATION = {
    desktop_image_url: {
        required: 'Banner desktop wajib diisi',
    },
    mobile_image_url: {
        required: 'Banner mobile wajib diisi',
    },
}
